/**
 * Cobranza se define en dos categorías del menú (#1243). Si «Finanzas internas»
 * la muestra, se quita de «Sistemas Internos»; y en Finanzas sólo la ve un
 * administrador de plataforma, igual que cuando vivía en Sistemas Internos.
 * Un tenant sin «Finanzas internas» la sigue viendo donde estaba.
 */
export function relocateCobranza<T extends { id: string; apps: { id: string }[] }>(categories: T[], isPlatformAdmin: boolean): T[] {
  const inFinance = categories.some((c) => c.id === "finanzas" && c.apps.some((a) => a.id === "cobranza"));
  if (!inFinance) return categories;
  return categories
    .map((c) => {
      if (c.id === "internos") return { ...c, apps: c.apps.filter((a) => a.id !== "cobranza") };
      if (c.id === "finanzas" && !isPlatformAdmin) return { ...c, apps: c.apps.filter((a) => a.id !== "cobranza") };
      return c;
    })
    .filter((c) => c.apps.length > 0);
}
